import React from 'react';
const RightSlider = (props) =>
{
	const { title, children } = props;

	return (
		<div className='flexCol'>

			<div className='flexCol pdngSM'>
				<div className='flexCol pdngXS'>
					<span className=''> {title}</span>
				</div>
				<div className='flexCol pdngXS'>
					<div className='flexRow pdngBSM'>
						{children}
					</div>
				</div>
			</div>
		</div>
	);
};

export default RightSlider;